import {
    BottomSheetContent as L2RBottomSheetContent,
    IconButton as UiIconButton,
    styledForMobile,
    styled,
} from "@l2r-front/l2r-ui"

import { DocumentFilterList as L2RDocumentFilterList } from "../DocumentFilterList"
import { DocumentFiltersForm as L2RDocumentFiltersForm } from "../DocumentFiltersForm"
import { DocumentsCountBadge as L2RDocumentCountBadge } from "../DocumentsCountBadge"

export const IconButton = styled(UiIconButton)(({ theme }) => ({
    marginLeft: "auto",
    height: "fit-content",
    zIndex: theme.zIndex.appBar + 2,
}))

export const DisplayedFiltersWrapper = styledForMobile("div")(() => ({
    display: "flex",
}))

export const Wrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    position: "relative",
})

export const DocumentFiltersForm = styled(L2RDocumentFiltersForm)(({ theme }) => ({
    backgroundColor: theme.palette["surfaces/surface-primary"].main,
    boxShadow: theme.shadows[27],
    left: 0,
    position: "absolute",
    right: 0,
    width: "100%",
    zIndex: theme.zIndex.appBar + 1,
}))

export const SideComponentContainer = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
}))

export const DocumentsCountBadge = styled(L2RDocumentCountBadge)(() => ({
    margin: 0,
}))

export const DocumentFilterList = styled(L2RDocumentFilterList)(({ theme }) => ({
    padding: theme.spacing(3, 0, 0, 0),
}))

export const BottomSheetContent = styled(L2RBottomSheetContent)(() => ({
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
    position: "relative",
}))